var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 bg-white my-course-wrapper"},[(!_vm.isAudition)?_c('course-content',{attrs:{"planClassesId":_vm.planClassesId,"showCourseProgress":_vm.showCourseProgress}}):_c('my-course-no-apply')],1)}
var staticRenderFns = []

export { render, staticRenderFns }